/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { usePathname } from 'next/navigation';
import { useForteDecisionFlagWithTrueDefault } from '@/features/forte/api/getForteDecision';
import { useLocale } from '@/hooks/useLocale';
import { localeCodes } from '@/features/i18n/constants/localeCodes';
import { TopHeaderV1 } from './TopHeaderV1';
import { TopHeaderV2 } from './TopHeaderV2';
import type { VehicleSummary } from '@/types';
import type { ContentStackHeaderPromo } from '@/features/contentstack/interface';
import { routePaths } from '@/constants/routePaths';

const CART_FULFILLMENT_GROUPING_ENABLED_LOCALES = [localeCodes.us];

type Props = {
  preferredVehicle: VehicleSummary | undefined;
  headerPromo: ContentStackHeaderPromo | undefined;
  rewardsBalance: number | undefined;
  showToast: boolean;
};

export const TopHeader = (props: Props) => {
  const pathname = usePathname();
  const locale = useLocale();
  const cartFulfillmentGroupingEnabled = useForteDecisionFlagWithTrueDefault(
    'cartFulfillmentGroupingEnabled',
  );
  const isCartPage = pathname === routePaths.cart;
  const isEnabledLocale = CART_FULFILLMENT_GROUPING_ENABLED_LOCALES.includes(locale);

  if (isCartPage && cartFulfillmentGroupingEnabled && isEnabledLocale) {
    const { rewardsBalance, ...v2Props } = props;
    void rewardsBalance;
    return <TopHeaderV2 {...v2Props} />;
  }

  return <TopHeaderV1 {...props} />;
};
